export const transformDriverBreakdown = (data) => {
    return {
      "Active Drivers": { main: data.driver_breakdown.active_drivers, diff: data.driver_breakdown.active_drivers_diff, precision: 0 },
      "Inactive Drivers": { main: data.driver_breakdown.inactive_drivers, diff: data.driver_breakdown.inactive_drivers_diff, precision: 0 },
      ...Object.fromEntries(
        data.driver_breakdown.fleet_drivers.map(([name, count]) => [
          name,
          { main: count, diff: null, precision: 0 },
        ])
      ),
    };
  };

  export const transformTripBreakdown = (data) => {
    return {
      "Total Trips": {
        main: data.trip_breakdown.fleet_trips,
        diff: data.trip_breakdown.trip_diff,
        precision: 0,
      },
      "Total Completions": {
        main: data.trip_breakdown.fleet_completions,
        diff: data.trip_breakdown.trip_complete_diff,
        precision: 0,
      },
      "Total Cancels": {
        main: data.trip_breakdown.fleet_cancellations,
        diff: data.trip_breakdown.trip_cancel_diff,
        precision: 0,
      },
    };
  };

  export const transformRideshareBreakdown = (data) => {
    return {
      "Uber Earnings": {
        main: data.rideshare_breakdown.uber_earnings,
        diff: data.rideshare_breakdown.uber_diff,
      },
      "Bolt Earnings": {
        main: data.rideshare_breakdown.bolt_earnings,
        diff: data.rideshare_breakdown.bolt_diff,
      },
      "Other Earnings": {
        main: data.rideshare_breakdown.other,
        diff: data.rideshare_breakdown.other_diff,
      },
    };
  };

  export const transformIncentiveBreakdown = (data) => {
    return {
      "Trips": {
        main: data.trip_breakdown.fleet_trips,
        precision: 0,
      },
      "Completions": {
        main: data.trip_breakdown.fleet_completions,
        precision: 0,
      },
      "Cancels": {
        main: data.trip_breakdown.fleet_cancellations,
        precision: 0,
      },
      "Performance Expenses": {
        main: data.incentive_breakdown.total_performance_expense,
      },
      "Payout": {
        main: data.incentive_breakdown.total_payout,
      },
      "Corporate Earnings": {
        main: data.incentive_breakdown.total_corporate_earnings,
      },
      "Bonus": {
        main: data.incentive_breakdown.total_bonus,
      },
      "Deduction": {
        main: data.incentive_breakdown.total_deduction,
      },
      "KM Overuse": {
        main: data.incentive_breakdown.total_km_overuse,
      },
      "Access to Site": {
        main: data.incentive_breakdown.total_access_to_site,
      },
      "Other": {
        main: data.incentive_breakdown.total_other,
      },
      "Uber": {
        main: data.incentive_breakdown.total_uber,
      },
      "Bolt": {
        main: data.incentive_breakdown.total_bolt,
      },
      "Fuel": {
        main: data.incentive_breakdown.total_fuel,
      },
      "Driver Balance Security": {
        main: data.incentive_breakdown.total_driver_balance_security,
       
      },
    };
  };  

  export const transformPaymentBreakdown = (data) => {
    return {
      "Total Fares": {
        main: data.payment_breakdown.total_fares,
        diff: data.payment_breakdown.fare_diff,
      },
      "Total Payout": {
        main: data.payment_breakdown.total_payout,
        diff: data.payment_breakdown.payout_diff,
      },
      "Total Incentives": {
        main: data.payment_breakdown.total_incentives,
        diff: data.payment_breakdown.incentive_diff,
      },
    };
  };
  
  export const transformFleetBalance = (data) => {
    return {
      "Balance (What's expected)": { main: data.fleet_balance.total_balance, diff: null },
      "Available Balance (What's coming)": { main: data.fleet_balance.total_available_balance, diff: null },
    };
  };
